<template>
  <no-auth-layout class="login-page">
    <h2 class="card-title center-align">Logowanie</h2>
    <p class="card-subtitle center-align">Zaloguj się, aby sprawdzić stan środków na Twoim koncie</p>

    <div class="social-auth-container">
      <div class="line-through-header center-align">
        <span>Zaloguj się za pomocą:</span>
      </div>
      <div class="row">
        <div class="col s12 m6 offset-m3">
          <button class="btn waves-effect waves-light red lighten-1" id="google"
            @click="authorize('google_oauth2')">
            <i class="mfind-icon mfind-icon-google_white left"></i>
            <span>Google</span>
          </button>
        </div>
      </div>
    </div>
    <div class="email-auth-container">
      <div class="line-through-header center-align">
        <span>lub przy użyciu <br>adresu email:</span>
      </div>
      <form @submit.prevent="submitLogin()" method="POST">
        <div v-if="data.errors" class="center-align validation-errors">
          <span class="red-text" v-if="data.errors['message']">{{ data.errors['message'].join(', ') }}</span>
          <span class="red-text" v-else>Nieprawidłowy login lub hasło, spróbuj ponownie</span>
        </div>

        <input-field type="email" name="email"
          label="Adres e-mail" v-model="data.email"
          required="true"/>

        <input-field type="password" name="password"
          label="Hasło" v-model="data.password"
          required="true"/>

        <button class="btn-large z-depth-0" type="submit">Zaloguj się</button>
      </form>
    </div>
    <br>
    <div class="card-footer">
      Nie pamiętasz <router-link :to="{ name: 'passForgot' }">hasła</router-link>?<br/>
      Nie masz konta? <router-link :to="{ name: 'register' }">Zarejestruj się</router-link> za darmo!
    </div>
    <Loader :loading="data.loading"/>
  </no-auth-layout>
</template>

<script>
import NoAuthLayout from '@/layouts/noAuthLayout'
import InputField from '@/components/inputs/text'
import Loader from '@/components/loader'
export default {
  name: 'login',
  components: { NoAuthLayout, InputField, Loader },
  data () {
    return {
      data: {
        loading: false,
        email: '',
        password: '',
        errors: false
      }
    }
  },
  beforeCreate () {
    if (!this.$store.getters.isLoggedIn) return

    if (this.$route.query.return_to_opener !== 'true') {
      this.$router.push({ name: 'dashboard' })
      return
    }

    let fetchUserEmail = () => this.$store.dispatch('getUser')
      .then(response => {
        if (response.code === 200) {
          return response.data.user.email
        }
      })
    let fetchUserMpcCode = () => this.$store.dispatch('promoCode')
      .then(response => {
        if (response.code === 200) {
          return response.data.mpc_code
        }
      })
    fetchUserEmail()
      .then(email => {
        return fetchUserMpcCode()
          .then(mpc => {
            this.$store.dispatch('confirmAuthorizationInB2c', { email: email, mpcCode: mpc })
          })
      })
  },
  methods: {
    authorize (provider) {
      this.data.loading = true
      this.$store.dispatch('authSocial', { provider })
        .then(
          response => {
            this.data.loading = false
            this.$router.push({ name: 'dashboard' })
          },
          errorResponse => { this.data.loading = false }
        )
    },
    submitLogin () {
      this.data.loading = true
      this.$store.dispatch('login', {
        email: this.data.email,
        password: this.data.password
      })
      .then(
        response => {
          this.data.loading = false
          if (response.code === 200) {
            if (response.returnToOpener) {
              return this.$store.dispatch('confirmAuthorizationInB2c', { email: this.data.email, mpcCode: response.mpcCode })
            }
            this.$router.push({ name: 'dashboard' })
          }
        },
        errorResponse => {
          this.data.loading = false
          this.data.errors = errorResponse.errors
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// login.vue?031ca15e